var _g, _path, _rect, _path2, _path3, _rect2, _path4, _path5, _g2, _path6, _circle, _circle2, _circle3, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphicinspiration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420,
    height: 205,
    fill: "none",
    viewBox: "0 0 420 205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M88.1 140.785a38.327 38.327 0 0 1-36.969-39.752c.476-14.78 33.32-64.44 37.278-70.336a4.182 4.182 0 0 1 3.752-1.857 4.268 4.268 0 0 1 3.607 2.124c3.288 5.917 32.622 58.015 32.084 72.852A38.328 38.328 0 0 1 88.1 140.785Zm10.767-47.08a12.803 12.803 0 1 0-18.751 17.439 12.803 12.803 0 0 0 18.75-17.439Zm11.972 86.195-48.252-1.75a4.188 4.188 0 0 1-3.321-1.691 4.431 4.431 0 0 1-.65-3.707l6.906-23.908a4.183 4.183 0 0 1 4.278-3.045l36.189 1.313a4.021 4.021 0 0 1 2.972 1.315 4.093 4.093 0 0 1 1.073 2.032l5.157 24.345a4.434 4.434 0 0 1-.918 3.651 4.183 4.183 0 0 1-3.434 1.445Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M91 29v61.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    x: 289,
    y: 15,
    fill: "#F2F1FF",
    rx: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "m330.035 57 10.557-10.557a8.226 8.226 0 0 0 2.41-5.818v-3.512A4.111 4.111 0 0 0 338.889 33h-3.512a8.214 8.214 0 0 0-5.815 2.41l-10.56 10.558-7.078-1.012A5.217 5.217 0 0 0 306.425 48c-.909 2.01-.302 4.393 1.259 5.951l14.366 14.366c1.558 1.559 3.942 2.166 5.951 1.257a5.213 5.213 0 0 0 3.045-5.5L330.035 57Z",
    opacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M333.748 45.338a3.084 3.084 0 1 0 0-6.169 3.084 3.084 0 0 0 0 6.169Zm-8.226 8.226a3.085 3.085 0 1 0 0-6.17 3.085 3.085 0 0 0 0 6.17Zm-14.953 3.276c-.247.183-.496.364-.718.586-1.472 1.472-2.681 5.943-3.399 9.196-.387 1.752 1.176 3.315 2.928 2.928 3.251-.717 7.724-1.927 9.196-3.399a6.02 6.02 0 0 0 .586-.718l-8.593-8.593Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 60,
    x: 97,
    y: 123,
    fill: "#E0F4FD",
    rx: 30
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6F4EF6",
    d: "M419 32.5v143"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6F4EF6",
    strokeWidth: 0.5,
    d: "M365 139H124m241 14H124m241 14H124"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#A286FA",
    strokeWidth: 0.5,
    d: "M172.589 31.042 184.2 42.61l-3.62 3.603-10.572-10.535a11.41 11.41 0 0 0 2.581-4.635ZM163.37.306l4.945 1.319-3.999 14.894-.085.317a11.564 11.564 0 0 0-2.7-.318c-.893 0-1.762.101-2.597.293L163.37.306Zm-5.018 16.655a11.483 11.483 0 0 0-4.612 2.588l-4.373-16.273 4.946-1.319 4.039 15.004Zm-5.009 2.907.032.032a11.438 11.438 0 0 0-2.753 4.463l-11.829-11.789 3.62-3.603 10.93 10.896Zm-3.088 10.29-15.949-4.256 1.325-4.927 14.818 3.957a11.428 11.428 0 0 0-.406 3.03c0 .753.075 1.487.212 2.196Zm29.936-21.594L169.262 19.46l-.02.02a11.474 11.474 0 0 0-4.67-2.556l.162-.162 11.837-11.8 3.62 3.603Zm7.042 11.86-14.791 3.948a11.437 11.437 0 0 0-2.813-4.528l16.279-4.347 1.325 4.927Zm-14.607 4.558 16.074 4.292-1.324 4.928-14.595-3.898c.157-.755.238-1.537.238-2.342 0-1.03-.137-2.03-.393-2.98Zm-3.939 28.244-3.846-14.298a11.461 11.461 0 0 0 4.59-2.657l4.202 15.636-4.946 1.319Zm-7.162-13.812c.846 0 1.666-.092 2.461-.265l-4.182 15.545-4.946-1.318 3.845-14.31c.903.225 1.847.348 2.822.348Zm-18.709 7.199 10.591-10.554a11.455 11.455 0 0 0 4.463 2.764l-11.434 11.393-3.62-3.603Zm-7.042-11.861 14.628-3.907a11.41 11.41 0 0 0 2.449 4.628l-15.752 4.207-1.325-4.928Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6F4EF6",
    strokeWidth: 0.5,
    d: "M252 26.5h-45c-5.523 0-10 4.477-10 10v42.98c0 7.572 9.156 11.364 14.51 6.01a8.5 8.5 0 0 1 6.011-2.49H252c5.523 0 10-4.477 10-10V36.5c0-5.523-4.477-10-10-10ZM211 42h37m-37 12h37m-37 12h37"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 371,
    cy: 153,
    r: 19,
    fill: "#8ADBFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 68,
    r: 7,
    fill: "#6F4EF6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 59,
    r: 4,
    fill: "#A286FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#A286FA",
    d: "M162.469 75A12.47 12.47 0 0 1 150 87.469a12.47 12.47 0 0 1 12.469 12.469 12.466 12.466 0 0 1 12.469-12.47A12.468 12.468 0 0 1 162.469 75Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF5",
    d: "M145.469 60A12.47 12.47 0 0 1 133 72.469a12.47 12.47 0 0 1 12.469 12.469 12.466 12.466 0 0 1 12.469-12.47A12.468 12.468 0 0 1 145.469 60Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h125.944v125.944H0z",
    transform: "matrix(.681 .73228 .73228 -.681 0 112.77)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h55v55H0z",
    transform: "translate(134)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicinspiration);
export default __webpack_public_path__ + "static/media/graphic inspiration.8e9f6d078a7e3fad092f597943b2fce4.svg";
export { ForwardRef as ReactComponent };